import { useParams } from "react-router-dom";
import Page from "../components/page";
import config from "../configs";
import icons from "../constants/icons";

const Media = () => {
  const { url } = useParams();

  return (
    <Page title={`Download - ${config.appName}`} noIndex hideLoader>
      <div style={{ minHeight: "70vh" }}>
        <br />
        <br />
        <a
          target="_blank"
          href={url && atob(url)}
          className="downloadBtn"
          rel="nofollow"
        >
          <img src={icons.down} />
          Download Server 1
        </a>
        <br />
        <a
          target="_blank"
          href={url && atob(url)?.replace("downloads", "download1")}
          className="downloadBtn"
          rel="nofollow"
        >
          <img src={icons.down} />
          Download Server 2
        </a>
        <br />
      </div>
    </Page>
  );
};

export default Media;
